import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const AgentPerformanceTable = ({ metrics, formatMoney }) => {
  if (!metrics?.agentPerformance?.length) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Agent Performance</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Agent</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Total Banks</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Active</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">In Process</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Freezed</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Freezed Amount</th>
              </tr>
            </thead>
            <tbody>
              {metrics.agentPerformance.map((agent) => (
                <tr key={agent.agentId} className="border-b hover:bg-slate-50">
                  <td className="p-3 font-medium">{agent.agentName}</td>
                  <td className="p-3">{agent.totalBanks}</td>
                  <td className="p-3 text-green-600 font-semibold">{agent.active}</td>
                  <td className="p-3 text-amber-600 font-semibold">{agent.inProcess}</td>
                  <td className="p-3 text-red-600 font-semibold">{agent.freezed}</td>
                  <td className="p-3 text-red-600 font-semibold">{formatMoney(agent.freezedAmount)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default AgentPerformanceTable;
